import { render, staticRenderFns } from "./paymentPortalV3.vue?vue&type=template&id=289a15bc&"
import script from "./paymentPortalV3.vue?vue&type=script&lang=js&"
export * from "./paymentPortalV3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports